// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./TicketManager.module.css";
// CSS
// Modules
import { useParams } from "react-router-dom";
// Modules
// Services
import { getSingleUserTicket } from "../../../../Services/Tickets/get/getSingleUserTicket";
// Services
// Contexts
import { UserTokenContext } from "../../../../Contexts/userToken";
import { I_TicketItem } from "../../../../Models/interfaces";
import TicketShower from "./TicketShower/TicketShower";
import TicketAdder from "./TicketAdder/TicketAdder";
import { toast } from "react-toastify";
// Contexts

type TicketManagerProps = {
  setIsNeedFullScreen?: React.Dispatch<React.SetStateAction<boolean>>;
};

const TicketManager: React.FunctionComponent<TicketManagerProps> = ({
  setIsNeedFullScreen,
}) => {
  // States
  const [currentSelectedPageMode, setCurrentSelectedPageMode] = useState<
    "ticketShow" | "ticketAdd" | undefined
  >(undefined);
  //
  const [trigger, setTrigger] = useState<boolean>(false);
  const [ticketData, setTicketData] = useState<I_TicketItem>({
    created_at: "",
    files: [],
    id: 0,
    last_update_at: "",
    status: { bgcolor: "", color: "", id: 1, name: "", open: 0, status: 1 },
    subject: "",
    text: "",
    ticket_answers: [],
    title: "",
    user: { fullName: "", id: 0, phone: "0" },
  });
  //
  const [isPending, setIsPending] = useState<boolean>(true);
  // States
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  const { ticketId } = useParams();
  const userToken = useContext(UserTokenContext);
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////

  useEffect(() => {
    if (setIsNeedFullScreen) {
      setIsNeedFullScreen(true);
      return () => {
        setIsNeedFullScreen(false);
      };
    }
  });

  useEffect(() => {
    if (!Number.isNaN(Number(ticketId))) {
      setCurrentSelectedPageMode("ticketShow");
      return;
    } else {
      setCurrentSelectedPageMode("ticketAdd");
      return;
    }
  }, [ticketId]);
  //
  useEffect(() => {
    if (currentSelectedPageMode === "ticketShow") {
      if (!ticketId) return;
      getSingleUserTicket(userToken, ticketId)
        .then(({ data }) => {
          setIsPending(false);
          console.log(data);
          setTicketData(data);
        })
        .catch((err) => {
          console.log(err);
          setIsPending(false);
          toast(
            err.response.data.message ? err.response.data.message : err.message,
          );
        });

      return;
    }
  }, [currentSelectedPageMode, userToken, ticketId, trigger]);
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////
  ///////////////////////////////////////////////////

  return (
    <div className={styles.mainContainer}>
      {currentSelectedPageMode === "ticketShow" ? (
        <TicketShower
          data={ticketData}
          ticketId={String(ticketId)}
          userToken={userToken}
          isPending={isPending}
          setTrigger={setTrigger}
        />
      ) : null}

      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}
      {/*  */}

      {currentSelectedPageMode === "ticketAdd" ? (
        <>
          <TicketAdder />
        </>
      ) : null}
    </div>
  );
};

export default TicketManager;
